import React from 'react';
import { Calendar, MapPin, Ticket } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../context/LanguageContext';

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center overflow-hidden pt-20">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/8tyxgp59_WhatsApp%20Image%202026-04-09%20at%2012.50.40.jpeg"
          alt="Battle Background"
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black via-black/80 to-black"></div>
      </div>

      {/* Animated Background Elements */}
      <div className="absolute inset-0 z-0">
        <div className="absolute top-20 left-10 w-32 h-32 bg-red-500/10 rounded-full blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-red-500/10 rounded-full blur-3xl animate-pulse delay-700"></div>
      </div>

      {/* Content */}
      <div className="container mx-auto px-4 z-10 text-center">
        <div className="max-w-4xl mx-auto space-y-8">
          {/* Logo */}
          <div className="flex justify-center mb-8 animate-fade-in">
            <img
              src="https://customer-assets.emergentagent.com/job_hdmi-breakdance/artifacts/4bt5sz02_nv%20logo.jpeg"
              alt="HDMI Team"
              className="h-32 w-auto object-contain"
            />
          </div>

          {/* Main Title */}
          <h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white tracking-tight animate-slide-up">
            <span className="block text-gray-400 text-3xl md:text-4xl mb-2">{t('hero_presents')}</span>
            {t('hero_title_1')}
            <span className="block text-red-500 mt-2">{t('hero_title_2')}</span>
          </h1>

          {/* Event Details */}
          <div className="flex flex-wrap justify-center gap-6 text-gray-300 animate-fade-in-delay">
            <div className="flex items-center space-x-2">
              <Calendar className="text-red-500" size={24} />
              <span className="font-medium">{t('hero_dates')}</span>
            </div>
            <div className="flex items-center space-x-2">
              <MapPin className="text-red-500" size={24} />
              <span className="font-medium">{t('hero_location')}</span>
            </div>
          </div>

          {/* Description */}
          <p className="text-lg md:text-xl text-gray-400 max-w-2xl mx-auto animate-fade-in-delay-2">
            {t('hero_description')}
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-6 animate-fade-in-delay-3">
            <Button
              onClick={() => window.open('https://www.helloasso.com/associations/association-la-structure/evenements/billeterie-battle-of-the-year-next-generation', '_blank')}
              className="bg-red-500 hover:bg-red-600 text-white font-bold px-8 py-6 text-lg transition-all duration-300 hover:scale-105 shadow-lg hover:shadow-red-500/50"
            >
              <Ticket className="mr-2" size={24} />
              {t('hero_cta_reserve')}
            </Button>
            <Button
              onClick={() => document.getElementById('program').scrollIntoView({ behavior: 'smooth' })}
              variant="outline"
              className="border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white font-bold px-8 py-6 text-lg transition-all duration-300"
            >
              {t('hero_cta_program')}
            </Button>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce z-10">
        <div className="w-6 h-10 border-2 border-gray-600 rounded-full flex justify-center">
          <div className="w-1 h-3 bg-red-500 rounded-full mt-2 animate-pulse"></div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
